import { useState, useEffect } from "react";
import ColorSchema from "../../kits/Color";
import { ArrowLeftIcon1 } from "../../kits/Icons";
import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";
import Select from "react-select";
const ALLOW_FIRST_OPERATOR = ["=", ">", ">=", "<", "<="];
export default function OperatorList({
  arrayOperator,
  addToPreview,
  firstOperator,
  deactivateItems,
  attributeProductList,
  chooseMainProperty,
  setPropertyId,
  propertyId,
  attributeBaseOnProduct,
}) {
  const [numbers, setNumbers] = useState([]);
  const numberList = () => {
    let temp = [];
    for (let i = 0; i < 10; i++) {
      temp.push(i);
    }
    setNumbers(temp);
  };
  useEffect(() => {
    numberList();
  }, []);

  return (
    <div dir="ltr" className="d-flex flex-column justify-content-center">
      {chooseMainProperty && (
        <div className="col-9 m-auto " dir="rtl">
          <ReactSelect
            title="انتخاب صفت اصلی"
            // itemsList={attributeProductList}
            itemsList={attributeBaseOnProduct.map((v) => {
              return { label: v.label, value: v.value };
            })}
            inputValue={propertyId}
            onChangeFunc={(e) => setPropertyId(e)}
            isClearable
          />
        </div>
      )}
      <div className="col-10 col-sm-5 m-auto " dir="rtl">
        <ReactSelect
          title="انتخاب صفت"
          itemsList={attributeProductList}
          onChangeFunc={(e) => addToPreview(e, "adjective")}
          activate={deactivateItems ? !deactivateItems : !firstOperator}
        />
      </div>
      <div className=" d-flex flex-wrap justify-content-center mx-auto">
        {arrayOperator.map((v) => (
          <OperatorItem
            operator={v}
            addToPreview={() => addToPreview(v, "operator")}
            firstOperator={
              deactivateItems
                ? deactivateItems
                : ALLOW_FIRST_OPERATOR.includes(v)
                ? !firstOperator
                : firstOperator
            }
          />
        ))}
      </div>
      <div className=" d-flex flex-wrap justify-content-center mx-auto">
        {numbers.map((v) => (
          <OperatorItem
            operator={v}
            addToPreview={() => addToPreview(v, "number")}
            firstOperator={deactivateItems ? deactivateItems : firstOperator}
          />
        ))}
      </div>
    </div>
  );
}
const OperatorItem = ({ operator, addToPreview, firstOperator }) => {
  return (
    <button
      className="m-1  rounded border d-flex align-items-center justify-content-center  "
      style={{
        backgroundColor: ColorSchema.success_custom,
        color: ColorSchema.white_custom,
        width: 25,
        height: 25,
        opacity: firstOperator && "0.4",
      }}
      disabled={firstOperator}
      onClick={addToPreview}
    >
      {operator}
    </button>
  );
};
